import { h } from 'preact';

interface QuickTipsOverlayProps {
  onDismiss: () => void;
}

interface Tip {
  icon: string;
  text: string;
}

const tips: Tip[] = [
  {
    icon: '1',
    text: 'Right-click any link or page to annotate it'
  },
  {
    icon: '2',
    text: 'Click the extension icon to see your vertices'
  },
  {
    icon: '3',
    text: 'Use Alt+Shift+V for quick annotations'
  }
];

export function QuickTipsOverlay({ onDismiss }: QuickTipsOverlayProps) {
  return (
    <div class="tips-overlay" onClick={onDismiss}>
      <div class="tips-modal" onClick={(e) => e.stopPropagation()}>
        <h2 class="tips-title">Quick Tips</h2>
        <ul class="tips-list">
          {tips.map((tip) => (
            <li key={tip.icon} class="tips-item">
              <span class="tips-icon">{tip.icon}</span>
              <span class="tips-text">{tip.text}</span>
            </li>
          ))}
        </ul>
        <button class="tips-dismiss" onClick={onDismiss}>
          Got it!
        </button>
      </div>
    </div>
  );
}
